const education = [
    {
      degree: "M.S. Mechanical Engineering",
      school: "Lehigh University",
      link: "https://www.lehigh.edu",
      location: "Bethlehem, PA",
      gpa: "3.89/4",
      year: "2021",
      courses: [
        "State Space Control",
        "Robot Motion Planning and Control",
        "Dynamics and Vibrations",
        "Mobile Robotics"
      ],
      researchAreas: ["Robotics", "Path Planning", "SLAM"]
    },
    {
      degree: "B.S. Mechanical Engineering",
      school: "Azad University",
      location: "Isfahan, IR",
      gpa: "3.65/4",
      year: "2012-2016",
      courses: [
        "Automatic Control",
        "Kinematics and Dynamics of Machines",
        "Hydraulic and Pneumatic Systems"
      ]
    }
];

export default education;